import React from 'react';
import { gql } from '@apollo/client';
import { Datagrid, ReferenceField, TextField } from 'react-admin';
import List from 'components/List';
import IdField from 'components/IdField';
import IdInput from 'components/Filter/IdInput';

const HrisLocationMappingList = () => (
  <List exporter={false} filters={[<IdInput />]}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <IdField />
      <ReferenceField
        label="Company"
        source="company_id"
        reference="Company"
        link="show"
        sortable={false}
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        label="Location"
        source="location_id"
        reference="Location"
        link="show"
        sortable={false}
      >
        <TextField source="name" />
      </ReferenceField>
      <TextField label="External ID" source="external_id" sortable={false} />
    </Datagrid>
  </List>
);

HrisLocationMappingList.query = gql`
  query hrisLocationMappings($input: HrisLocationMappingQueryInput) {
    _hrisLocationMappingsMeta(input: $input) {
      count
    }
    hrisLocationMappings(input: $input) {
      id
      company_id
      location_id
      external_id
    }
  }
`;

export default HrisLocationMappingList;
